import { ref } from 'vue';
import deleteAnimation from '@/components/widgets/gsqxdxog.json';
import '@vueform/multiselect/themes/default.css';
import Lottie from '@/components/widgets/lottie.vue';
export default {
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    attachment: {
      type: String,
      default: ''
    }
  },
  components: {
    Lottie
  },
  data() {
    return {
      deleteAnimationData: {
        loop: true,
        autoplay: true,
        animationData: deleteAnimation,
        rendererSettings: {
          preserveAspectRatio: 'xMidYMid slice'
        }
      },
      localModalVisible: this.modelValue,
      attachmentModelData: {
        ...this.initialData
      },
      inputFile: ref(null)
    };
  },
  computed: {},
  watch: {
    modelValue(newVal) {
      if (!newVal) {
        this.attachmentModelData = {
          ...this.initialData
        };
      }
      this.localModalVisible = newVal;
    },
    localModalVisible(newVal) {
      if (newVal === false) this.closeModal();
    }
  },
  methods: {
    isImage(filename) {
      if (!filename) return false;
      var ext = filename?.split('.').pop() ?? '';
      ext = ext.toUpperCase();
      return ext == 'PNG' || ext == 'JPG' || ext == 'JPEG';
    },
    closeModal() {
      this.$emit('update:modelValue', false);
    }
  }
};